import React from "react";
import LogoDirecionalRiva from "../../Components/LogoDirecionalRiva";
import BannerHome from "../../assets/BannerInterno.png";
import Fade from "@material-ui/core/Fade";
import PodeMorar from "../../assets/novosicones/podemorarfull.svg";
import PrecisaAjuda from "../PrecisaDeAjuda";
import { Link } from "react-router-dom";
import { ReactSVG } from "react-svg";

import "./styles.scss";

const BaseComponentFluxoLogin = ({ precisaDeAjuda, children }) => {
  return (
    <div className="home centralized">
      <div className="container__loginComponent centralized-column">
        <div className="centralized-column">
          <div className="container__loginComponent__logo centralized">
            <Link to="/">
              <ReactSVG src={PodeMorar} />
            </Link>
          </div>
          <Fade in>
            <div className="container__loginComponent__component centralized">
              {children}
              {precisaDeAjuda != false && <PrecisaAjuda posicaoY={"5%"} />}
            </div>
          </Fade>
        </div>
        <LogoDirecionalRiva />
      </div>
      <div className="container__banner">
        <Fade in>
          <img
            className="banner-home"
            src={BannerHome}
            alt="Banner Página Login"
          />
        </Fade>
      </div>
    </div>
  );
};

export default BaseComponentFluxoLogin;
